import { createClient } from '@supabase/supabase-js'

export function getSupabaseAdminClient() {
  // SECURITY: Use SUPABASE_URL (server-only) first, fallback to NEXT_PUBLIC_ for URL only
  const supabaseUrl = process.env.SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL
  // SECURITY: NEVER use NEXT_PUBLIC_ for service role key - it exposes it to the browser
  const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY

  if (!supabaseUrl) {
    console.error('Missing Supabase URL environment variable');
    throw new Error('Missing Supabase URL environment variable. Please set SUPABASE_URL')
  }

  if (!serviceRoleKey) {
    console.error('Missing Supabase service role key environment variable');
    throw new Error('Missing Supabase service role key. Please set SUPABASE_SERVICE_ROLE_KEY (server-only, never NEXT_PUBLIC_)')
  }

  return createClient(supabaseUrl, serviceRoleKey, {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    },
    global: {
      headers: {
        'apikey': serviceRoleKey,
      },
    },
  })
}

// WARNING: This module must ONLY be imported by server-side code (pages/api/*).
// Never import this from client-side pages or components — it will crash
// because SUPABASE_SERVICE_ROLE_KEY is not available in the browser.
export const supabaseAdmin = getSupabaseAdminClient()
